import { render, staticRenderFns } from "./GamesHelp.vue?vue&type=template&id=4507ae68"
import script from "./GamesHelp.vue?vue&type=script&lang=js"
export * from "./GamesHelp.vue?vue&type=script&lang=js"
import style0 from "./GamesHelp.vue?vue&type=style&index=0&id=4507ae68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports